'use client'

import { useRouter } from '@/i18n/navigation'
import { useEffect } from 'react'
import { PROVIDER_ROUTES } from '../constants/routes'
import { useAuth } from '../store/auth'
import { AccountType } from '../types/enums/account-type.enum'

type Props = {
  children: React.ReactNode
}
export const ProviderAuthGuard: React.FC<Props> = ({ children }) => {
  const { user, status } = useAuth()
  const router = useRouter()
  useEffect(() => {
    if (status === 'pending') return
    if (user && user.accountType === AccountType.PROVIDER) {
      router.replace(PROVIDER_ROUTES.trips)
    }
  }, [router, user, status])
  return children
}
